module.exports = __webpack_public_path__ + "static/media/MenuIcon.da8db37d.svg";